/*
 * Copyright (c) Worldline 2023.
 */

import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";

@Injectable({
    providedIn: 'root'
})
export class RootScopeService {


    private rootScope: any = {}

    constructor(private httpClient: HttpClient) {
        console.log("create a new RootScopeService")
    }

    get() {
        return this.rootScope;
    }
}
